/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment, useState } from 'react'

import { EuiButton } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import FiltersFlyout from './FiltersFlyout'
import FiltersPanel from './FiltersPanel'

interface Props {
  flyoutMode?: boolean
  isLoading: boolean
}

const Settings = ({ flyoutMode, isLoading }: Props) => {
  const [isFlyoutVisible, setIsFlyoutVisible] = useState(false)

  const toggleFlyout = () => setIsFlyoutVisible(!isFlyoutVisible)

  if (flyoutMode) {
    return (
      <Fragment>
        <EuiButton
          onClick={toggleFlyout}
          fullWidth={true}
          data-test-id='billing-usage.show-filters-button'
        >
          <FormattedMessage id='billing-usage.show-filters' defaultMessage='Show view controls' />
        </EuiButton>
        {isFlyoutVisible && <FiltersFlyout toggleFlyout={toggleFlyout} isLoading={isLoading} />}
      </Fragment>
    )
  }

  return <FiltersPanel isLoading={isLoading} />
}

export default Settings
